// extracted by mini-css-extract-plugin
export default {"wrapper":"text__wrapper__DZkhJ","title":"text__title__zUlGB","body":"text__body__FDSbH","img":"text__img__hHCC6"};